import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Tabs } from "@performyard/py-components";

import ReviewFormsTable from "./ReviewFormsTable";
import ReviewCycleReviewsDetailsTable from "./Table";

import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

const TAB_VALUES = ["subjects", "forms"];

const ReviewCycleDetailsTabs = ({ reviewCycleId }: { reviewCycleId: string }) => {
	const { value: isOptionsRefreshEnabled } = useFeatureFlagQuery(
		"ff-temp-is-review-cycle-options-refresh-enabled",
		false
	);
	const [searchParams, setSearchParams] = useSearchParams();
	const requestedTab = searchParams.get("tab");
	const [activeTab, setActiveTab] = useState(
		requestedTab && TAB_VALUES.includes(requestedTab) ? requestedTab : "subjects"
	);

	// ?tab= is a one-shot handoff (e.g. returning from the Add Forms page) —
	// consume it and strip it so it doesn't linger in the URL or history.
	useEffect(() => {
		if (!requestedTab) return;
		const next = new URLSearchParams(searchParams);
		next.delete("tab");
		setSearchParams(next, { replace: true });
	}, [requestedTab, searchParams, setSearchParams]);

	if (!isOptionsRefreshEnabled) {
		return <ReviewCycleReviewsDetailsTable reviewCycleId={reviewCycleId} />;
	}

	return (
		<Tabs
			value={activeTab}
			onValueChange={setActiveTab}
			size="large"
			tabs={[
				{
					value: "subjects",
					label: "Review Subjects",
					content: (
						<div className="mt-6">
							<ReviewCycleReviewsDetailsTable reviewCycleId={reviewCycleId} />
						</div>
					),
				},
				{
					value: "forms",
					label: "Review Forms",
					content: (
						<div className="mt-6">
							<ReviewFormsTable reviewCycleId={reviewCycleId} />
						</div>
					),
				},
			]}
		/>
	);
};

export default ReviewCycleDetailsTabs;
